import { type CommandProps, InputRule } from '@tiptap/core';
import BaseHeading, { type Level } from '@tiptap/extension-heading';
import { isInTable } from './proseMirrorTypes';

export const Heading = BaseHeading.extend({
  addCommands() {
    const parentCommands = this.parent?.();
    return {
      ...parentCommands,
      setHeading: (attributes: { level: Level }) => (props: CommandProps) =>
        !isInTable(props.state) &&
        Boolean(parentCommands?.setHeading?.(attributes)(props)),
      toggleHeading: (attributes: { level: Level }) => (props: CommandProps) =>
        !isInTable(props.state) &&
        Boolean(parentCommands?.toggleHeading?.(attributes)(props)),
    };
  },

  addInputRules() {
    const parentRules = this.parent?.() ?? [];
    return parentRules.map(
      rule =>
        new InputRule({
          find: rule.find,
          undoable: rule.undoable,
          handler: props =>
            isInTable(props.state) ? null : rule.handler(props),
        })
    );
  },
});
